import React from 'react';

export const entireAgreementMessages = {
  value: 'Entire Agreement',
  list: [
    {
      value: (
        <>
          The Terms and Conditions shall constitute the entire agreement between
          user and Glints relating to his/her/its use of the Site, and shall
          replace and supersede all other communications (be it written or
          oral), discussions, letters and contracts relating to the subject
          matters hereof.
        </>
      ),
    },
  ],
};
